export default class userRights {
  constructor(){}

  /**
  * Test has a user a right
  * @param {string} right - user right name 
  * @param {string} role - user role name
  * @return {boolean} true if user's group has a right, false if not
  */
  hasRight( right, role ) {
    let groupAndRights = { RIGHTS: window.RIGHTS, GROUPS: window.USER_GROUPS };

    if( !Object.keys( groupAndRights.RIGHTS ).includes( right ) ) {
      throw new Error(`Error: given right is not configured to group & rights module. Passed right: '${right}' `);
    }

    if( role ) {
      const rightsArray = groupAndRights.GROUPS[ role ];      
      return Array.isArray( rightsArray ) && rightsArray.includes( right ); 
    }

    return false;    
  }
  
}
